// extracted by mini-css-extract-plugin
export default {"seperator":"Zc3_J2"};